"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var dayjs_1 = __importDefault(require("dayjs"));
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var context_1 = require("../../../context");
var DateInput_1 = __importDefault(require("../../DateInput"));
var FormControl_1 = __importDefault(require("../../FormControl"));
var Input_1 = __importStar(require("../../Input"));
var DateOfBirthAgeInput = function () {
    var trans = context_1.useSemantics().trans;
    var _a = formik_1.useFormikContext(), values = _a.values, setFieldValue = _a.setFieldValue, errors = _a.errors;
    var calculateAgeFromDob = react_1.useCallback(function (dob) {
        return dayjs_1.default().diff(dayjs_1.default(dob, 'DD/MM/YYYY'), 'year');
    }, []);
    react_1.useEffect(function () {
        if (values.dob) {
            setFieldValue('age', calculateAgeFromDob("" + values.dob), false);
        }
    }, [values.dob]);
    return (react_1.default.createElement("div", { className: "flex max-w-lg" },
        react_1.default.createElement("div", { className: "w-full max-w-xs" },
            react_1.default.createElement(FormControl_1.default, { errors: errors.dob, dusk: "dob-field", label: trans('optiiva::labels.dob') },
                react_1.default.createElement(DateInput_1.default, { name: "dob" }))),
        react_1.default.createElement("div", { className: "flex-grow pl-6" },
            react_1.default.createElement(FormControl_1.default, { errors: errors.age, dusk: "age-field", label: trans('optiiva::labels.age') },
                react_1.default.createElement(Input_1.default, { name: "age", type: Input_1.InputType.number, step: 1, min: 0, max: 200 })))));
};
exports.default = DateOfBirthAgeInput;
//# sourceMappingURL=DateOfBirthAgeInput.js.map